import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupAll = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/getmyusergroupall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/getmyusergrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getTeamReport = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/getteamreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const uploadMaintainPicture = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/uploadmaintainpicture/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const removeMaintainPicture = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/removemaintainpicture/' + params.maintainPictureId + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const cancel = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/cancel/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const confirmMaintained = (params, urlParams) => {
  return axios.request({
    url: '/om/technicalassistance/confirmmaintained' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}
